import { CleanDatePipe } from './../../../pipes/clean-date.pipe';
import { TrackingHistoryService } from './service/tracking-history.service';
import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable, forkJoin, map, throwError, catchError, of } from 'rxjs';
import { TrackingHistory } from './model/tracking-history.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';

@Component({
    selector: 'tracking-history',
    templateUrl: './tracking-history.component.html',
    styleUrls: ['./tracking-history.component.scss']
})
export class TrackingHistoryComponent implements OnInit {
    @Input() formName: string;
    @Input() formID: string;

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    // Table display
    displayedColumns: string[] = ['CHANGED_DATE', 'CHANGED_BY', 'CHANGED_FIELD', 'CHANGED_VALUE'];

    // Table results
    tableDataSource!: MatTableDataSource<TrackingHistory>;

    trackingHistory: TrackingHistory[] = [];

    isLoading: boolean = false;
    submitting: boolean = false;

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();

    constructor(private trackingHistoryService: TrackingHistoryService) {}

    ngOnInit(): void {
        this.getAll();
    }

    getAll() {
        this.isLoading = true;
        let obs: Observable<any>[] = [];

        obs.push(this.index());

        forkJoin(obs).subscribe((res) => {
            // Updates the Tables to be displayed w/ this.results
            if (this.trackingHistory.length > 0) {
                this.updateDataSource();
            }

            this.isLoading = false;
        });
    }

    index() {
        return this.trackingHistoryService.index(this.generatePayload()).pipe(
            map((res: any) => {
                if (res.trackingHistory) {
                    this.trackingHistory = res.trackingHistory;
                    this.trackingHistory.forEach((th) => {
                        th.CHANGED_DATE = this.cleanDatePipe.transform(th.CHANGED_DATE!);
                    });

                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving history.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    generatePayload() {
        let payload: any = {};

        payload.formName = this.formName;
        payload.formID = this.formID;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<TrackingHistory>();
            this.tableDataSource.data = this.trackingHistory;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'CHANGED_DATE', direction: 'desc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }
}
